export default __webpack_public_path__ + "img/733ebd8ed995bcdf5ace6c146bd4937f.svg";